//テストコード
/* $(function() {
  $("p").hide();
}); */

$(function () {
 
    var nextShowTime = $.cookie('nextshowtime');
    nextShowTime = (nextShowTime) ? new Date(nextShowTime) : new Date();
    var lastShowDate = $.cookie('lastshowdate');
    lastShowDate = (lastShowDate) ? new Date(lastShowDate) : new Date();
    lastShowDate = new Date(lastShowDate.getFullYear(), lastShowDate.getMonth(), lastShowDate.getDate());
    var showCount = $.cookie('showcount');
    showCount = (showCount) ? Number(showCount) : 0;
  
    var now = new Date();
  
    if (now >= nextShowTime){
      // 表示可能時間を過ぎていたら
      if (now.toDateString() == lastShowDate.toDateString()){
        // 同一日の場合
        if(showCount < 2){
          // 3.セッションに関係なく【1日2回】まで表示
          $(".modal").css("display","flex");
          showCount ++;
        }else{
          // 2回以上の場合
          $(".modal").css("display","none");
        }
      }else{
        // 同一日ではない場合
        $(".modal").css("display","flex");
        showCount ++;
      }
    }else{
      // まだ表示不可時間
      $(".modal").css("display","none");
    }
    // クッキー書込み
    $.cookie("lastshowdate", (lastShowDate) ? lastShowDate.toLocaleString('ja') : '', { expires: 1, path: "/", secure: true });
    $.cookie("showcount", showCount, { expires: 1, path: "/", secure: true });
  
});
  
  
  
  var popup = document.getElementById('popup');
  var popup_closeBtn = document.getElementById('popup-closeBtn');
  
  popup_closeBtn.addEventListener('click', function() {
    popup.style.display = 'none';
  })
  
  
  window.addEventListener('click', function(e) {
      if (e.target == popup) {
        popup.style.display = 'none';
      }
    });